
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M19 14.095v22.909M25.545 30.459L19 37.004l-6.545-6.545M24.727 25.55h5.728a6.545 6.545 0 000-13.091h0C30.012 5.96 24.579.935 18.066 1c-6.513.065-11.845 5.198-12.157 11.703A6.486 6.486 0 001 19.004a6.565 6.565 0 006.545 6.546h5.728"}})])])
          )
        }
      }
    